module.exports = __webpack_public_path__ + "static/media/181IT124.5eaf35a5.jpg";